const cantSendYet = Symbol();
export default class ActionQueue {
    constructor() {
        this._awaitAddingQueue = [];
        this._queue = {};
        this._idPool = {};
        this._batchPull = {};
        this._backId = [];
        this.add = this.add.bind(this);
    }
    resolve(id, type) {
        const col = this._backId[type];
        if (typeof col === "undefined")
            return id;
        const tID = col[id];
        return typeof tID === "undefined" ? id : tID;
    }
    add(action, data, proc) {
        if (proc.debounce) {
            const bid = data.batchID;
            delete data.batchID;
            const qid = `${action}"/"${bid || data.id}`;
            if (bid) {
                if (!this._batchPull[bid]) {
                    this._batchPull[bid] = [];
                }
                this._batchPull[bid].push(data);
            }
            const item = this._queue[qid];
            if (item) {
                clearTimeout(item);
            }
            this._queue[qid] = setTimeout(() => {
                const opbatch = this._batchPull[bid];
                if (opbatch && opbatch.length > 1) {
                    data = { opbatch };
                }
                this.add(action, data, { ...proc, debounce: false });
            }, proc.debounce);
            return;
        }
        const ready = this.tryExec(action, data, proc);
        if (ready === null) {
            //can't send data yet
            this._awaitAddingQueue.push({ action, data, proc });
        }
        else {
            ready.then((res) => {
                if (res &&
                    res.id &&
                    res.id != data.id &&
                    this.isTempID(data.id)) {
                    this._idPool[data.id] = res.id;
                    this.execQueue();
                }
            });
        }
    }
    tryExec(action, data, proc) {
        const ready = this.exec(action, data, proc);
        if (ready === null) {
            this._awaitAddingQueue.push({ action, data, proc });
        }
        else {
            ready.then((res) => {
                if (res &&
                    res.id &&
                    res.id != data.id &&
                    this.isTempID(data.id)) {
                    this._idPool[data.id] = res.id;
                    if (proc.kind) {
                        let t = this._backId[proc.kind];
                        if (!t)
                            t = this._backId[proc.kind] = {};
                        t[res.id] = data.id;
                    }
                    this.execQueue();
                }
            });
        }
        return ready;
    }
    exec(action, data, proc) {
        const correctData = this.correctID(data, proc.ignoreID ? data.id : null, proc.skipCorrect);
        if (correctData === cantSendYet) {
            return null;
        }
        return proc.handler(correctData, action, data);
    }
    isTempID(v) {
        return (typeof v === "string" &&
            v.length === 20 &&
            parseInt(v.substr(7)) > 1e12); // new Date(2000,0)
    }
    correctID(obj, ignore, skipCorrect) {
        let copy = null;
        for (const key in obj) {
            if (skipCorrect && skipCorrect.includes(key))
                continue;
            const test = obj[key];
            if (typeof test === "object") {
                const after = this.correctID(test, ignore, skipCorrect);
                if (after !== test) {
                    if (after === cantSendYet) {
                        return cantSendYet;
                    }
                    if (copy === null) {
                        if (Array.isArray(obj))
                            copy = [...obj];
                        else
                            copy = { ...obj };
                    }
                    copy[key] = after;
                }
            }
            else if ( /* test !== ignore &&  */this.isTempID(test)) {
                const hasRealID = this._idPool[test];
                // test !== ignore check moved below to allow ID corrections when it's necessary to pass them in payload for restoring previously created and deleted projects
                if (test !== ignore && !hasRealID) {
                    return cantSendYet;
                }
                if (copy === null) {
                    // this needs to be fixed in lib-data-provider
                    if (Array.isArray(obj))
                        copy = [...obj];
                    else
                        copy = { ...obj };
                }
                copy[key] = hasRealID;
            }
        }
        return copy || obj;
    }
    execQueue() {
        this._awaitAddingQueue = this._awaitAddingQueue
            .map(a => {
            return this.tryExec(a.action, a.data, a.proc) ? null : a;
        })
            .filter(a => a !== null);
    }
    setID(tid, id, kind) {
        this._idPool[tid] = id;
        if (kind) {
            let t = this._backId[kind];
            if (!t)
                t = this._backId[kind] = {};
            t[id] = tid;
        }
    }
}
//# sourceMappingURL=ActionQueue.js.map